{
  "dottnet.home.change-theme": "Cambia tema",
  "dottnet.home.check-blogs": "or check blogs home",
  "dottnet.home.contributors.description1": "Want to start contributing to open source with Angular?",
  "dottnet.home.contributors.description2": "Leave your mark and join the growing team of contributors!",
  "dottnet.home.contributors.description3": "Get started by having a look on ",
  "dottnet.home.contributors.description4": " and ",
  "dottnet.home.contributors.guide": "Contributor guide",
  "dottnet.home.contributors.issues": "open issues",
  "dottnet.home.contributors.title": "Contributors",
  "dottnet.home.get-notified.description": "a Twitter bot that helps you to stay up to date with releases of popular frontend frameworks & libraries!",
  "dottnet.home.get-notified.follow": "Follow",
  "dottnet.home.get-notified.title": "Get notified home new releases",
  "dottnet.home.get-started": "Get started",
  "dottnet.home.follow-us": "Seguici su",
  "dottnet.features.angular": "Modern powerful framework",
  "dottnet.features.angular-cli": "A command line interface for Angular",
  "dottnet.features.angular-material": "Material design component library",
  "dottnet.features.bootstrap": "Responsive layout from battle tested, world most famous UI library",
  "dottnet.features.cypress": "Cypress is a next generation front end testing tool built for the modern web.",
  "dottnet.features.documentation": "Docs",
  "dottnet.features.fontawesome": "Easy to use vector icons and social logos",
  "dottnet.features.guide": "Guide",
  "dottnet.features.lazyloading.description": "Faster startup time with lazy loaded feature modules",
  "dottnet.features.lazyloading.title": "Lazy loading",
  "dottnet.features.ngrx": "One way data flow powered by RxJS Observables",
  "dottnet.features.ngxtranslate": "An internationalization library for Angular",
  "dottnet.features.rxjs": "Reactive programming with async collections using Observables",
  "dottnet.features.themes.description": "Flexible theming support for provided and custom components",
  "dottnet.features.themes.title": "Themes",
  "dottnet.features.title": "Features",
  "dottnet.features.typescript": "Superior developer experience, code completion, refactoring and less bugs",
  "dottnet.features.eslint": "ESLint is for identifying problematic patterns found in JavaScript and Typescript code",
  "dottnet.footer.changelog": "Show changelog",
  "dottnet.header.github": "Project Github Repository",
  "dottnet.menu.home": "Home",
  "dottnet.menu.content": "Contenuti",
  "dottnet.menu.news": "News",
  "dottnet.menu.document": "Documenti",
  "dottnet.menu.dossier": "Dossier",
  "dottnet.menu.video": "Video",
  "dottnet.menu.canale": "Canali",
  "dottnet.menu.minisito": "Minisiti",
  "dottnet.menu.offline": "Offline",
  "dottnet.menu.blog": "Blog",
  "dottnet.menu.professional": "Professionali - Societari",
  "dottnet.menu.patient": "Associazione pazienti",
  "dottnet.menu.rarediseasepatient": "Associazione pazienti malattie rare",
  "dottnet.menu.extra": "eXtra",
  "dottnet.menu.discoverextra": "Scopri eXtra",
  "dottnet.menu.myextra": "Il mio eXtra",
  "dottnet.menu.mycourses": "I miei corsi",
  "dottnet.menu.articleextra": "Articoli eXtra",
  "dottnet.menu.privacybox": "Privacy box",
  "dottnet.menu.iframe": "Iframe",
  "dottnet.menu.toolbox": "Toolbox",
  "dottnet.menu.fad": "Fad",
  "dottnet.menu.pec": "Pec",
  "dottnet.menu.mail": "Mail",
  "dottnet.menu.list": "Lista",
  "dottnet.menu.examples": "Esempi",
  "dottnet.menu.features": "Features",
  "dottnet.menu.accedi": "Accedi a DottNet",
  "dottnet.menu.login": "Accedi",
  "dottnet.menu.signup": "Registrati",
  "dottnet.menu.logout": "Logout",
  "dottnet.menu.settings": "Preferenze",
  "dottnet.menu.profile": "Profilo",
  "dottnet.menu.managelog": "Gestisci log",
  "dottnet.menu.schedario": "Schedario",
  "dottnet.menu.ricerca": "Cosa stai cercando?",
  "dottnet.menu.ecm": "ECM",
  "dottnet.settings.animations.elements": "Navigation page elements slide up",
  "dottnet.settings.animations.page": "Navigation whole page transition",
  "dottnet.settings.animations.title": "Animazioni",
  "dottnet.settings.general.language.de": "German",
  "dottnet.settings.general.language.en": "English",
  "dottnet.settings.general.language.es": "Spanish",
  "dottnet.settings.general.language.fr": "French",
  "dottnet.settings.general.language.he": "Hebrew",
  "dottnet.settings.general.language.pt-br": "Portuguese",
  "dottnet.settings.general.language.sk": "Slovak",
  "dottnet.settings.general.language.zh-cn": "Simple Chinese",
  "dottnet.settings.general.placeholder": "Lingua",
  "dottnet.settings.general.title": "General",
  "dottnet.settings.themes.blue": "Blue",
  "dottnet.settings.themes.dark": "Dark",
  "dottnet.settings.themes.light": "Light",
  "dottnet.settings.themes.nature": "Nature",
  "dottnet.settings.themes.night-mode": "Auto night mode (from 21:00 to 7:00)",
  "dottnet.settings.themes.placeholder": "Color Theme",
  "dottnet.settings.themes.saneago": "",
  "dottnet.settings.themes.sticky-header": "Sticky header",
  "dottnet.settings.themes.title": "Temi",
  "dottnet.settings.title": "Preferenze",
  "dottnet.title.long": "DottNet",
  "dottnet.title.short": "DottNet",
  "dottnet.login.required": "Il campo non può essere vuoto",
  "dottnet.login.username": "Email",
  "dottnet.login.password": "Password",
  "dottnet.login.rememberme": "Ricordami",
  "dottnet.login.submit": "Accedi",
  "dottnet.login.error": "C'è stato un errore:",
  "dottnet.login.email": "Inserisci l'email:",
  "dottnet.login.pwd": "Recupera",
  "dottnet.login.pwdforbidden": "Recupera password",
  "dottnet.login.register": "Registrati",
  "dottnet.schedario.medici": "Medici",
  "dottnet.schedario.cercamedici": "Cerca Medico",
  "dottnet.schedario.carica": "Carica Schedario",
  "dottnet.logs.searchtext": "cerca nei log",
  "dottnet.logs.delete": "DBLog svuotato. Cancellati {{value}} records",
  "dottnet.progettiazioni.selezionaprogettoazione": "Seleziona Progetto e azione",
  "dottnet.progettiazioni.selezionaprogetto": "Seleziona Progetto",
  "dottnet.progettiazioni.selezionaazione": "Seleziona Azione",
  "dottnet.shared.cerca": "Cerca...",
  "dottnet.shared.generic_select": "Seleziona un'opzione",
  "dottnet.shared.generic_placeholder": "Scrivi...",
  "dottnet.shared.nessunrisultato": "Nessun risultato",
  "dottnet.shared.category": "Categoria",
  "dottnet.shared.specialty": "Specializzazione",
  "dottnet.schedario.visite_ciclo": "Visite per ciclo",
  "dottnet.schedario.in_schedario": "In Schedario",
  "dottnet.schedario.personalizza_visite": "Visite",
  "dottnet.schedario.minimo_visite": "Da",
  "dottnet.schedario.massimo_visite": "A",
  "dottnet.operatori.selezionaoperatore": "Operatore",
  "dottnet.specializzazioni.selezionaspecializzazione": "Specializzazione",
  "dottnet.situazione-cliente": "Situazione Cliente",
  "dottnet.situazione-cliente.short": "Sit. Cliente",
  "dottnet.domande-risposte": "Domande e risposte",
  "dottnet.domande-risposte.select_istanza": "Seleziona un istanza",
  "dottnet.domande-risposte.select_date": "Seleziona una data",
  "dottnet.domande-risposte.short": "Dom/Ris",
  "dottnet.dottnet.last-login": "Ultima Login",
  "dottnet.dottnet.username": "Username",
  "dottnet.dottnet.password": "Password",
  "dottnet.dottnet.premium": "Premium",
  "dottnet.progettimail.selectmail": "Mail",
  "dottnet.shared.required": "Campo obbligatorio",
  "dottnet.shared.research": "Risultati di ricerca",
  "dottnet.shared.emptyresults": "Non sono presenti risultati per questa ricerca",
  "dottnet.filtri.selectfiltro": "Filtro",
  "dottnet.shared.search": "Carica",
  "dottnet.shared.id_anagrafica": "Id_Anagrafica",
  "dottnet.shared.nome": "Nome",
  "dottnet.shared.cognome": "Cognome",
  "dottnet.shared.categoria": "Categoria",
  "dottnet.shared.listapersonale": "Lista Personale",
  "dottnet.shared.schedario": "Schedario",
  "dottnet.shared.ricercasemplice": "Ricerca semplice",
  "dottnet.categorie.selezionacategoria": "Categoria",
  "dottnet.shared.provincia": "Provincia",
  "dottnet.shared.localita": "Comune",
  "dottnet.shared.indirizzo": "Indirizzo",
  "dottnet.shared.email": "Email",
  "dottnet.shared.cf": "Codice Fiscale",
  "dottnet.shared.recapito": "Recapito Telefonico",
  "dottnet.shared.ricercanagrafica": "Ricerca Id_Anagrafica",
  "dottnet.shared.ricercavanzata": "Avanzate",
  "dottnet.shared.entita": "Entita",
  "dottnet.shared.assegnati": "Assegnati",
  "dottnet.shared.reclutati": "Reclutati",
  "dottnet.shared.searchselect": "Selezionare un metodo di ricerca",
  "dottnet.shared.altro": "Altro",
  "dottnet.shared.assistenza": "Qualcosa è andato storto. Contattare l'assistenza.",
  "dottnet.shared.attenzione": "Attenzione",
  "dottnet.shared.moreContent": "Mostra Altri",
  "dottnet.shared.showMore": "Mostra altro",
  "dottnet.shared.showLess": "Mostra meno",
  "dottnet.claimAccess.title.prefix": "Siamo oltre ",
  "dottnet.claimAccess.title.highlight": "250.000 medici",
  "dottnet.claimAccess.title.suffix": ": aggiornati e informati.",
  "dottnet.claimAccess.description": "Ogni giorno pubblichiamo per te tanti contenuti e li organizziamo perchè tu possa sempre trovare ciò che vuoi.",
  "dottnet.claimAccess.login": "Accedi",
  "dottnet.claimAccess.register": "Registrati",
  "dottnet.wall.title": "Aggiorna Dati",
  "dottnet.wall.dati_professionali": "Dati professionali",
  "dottnet.wall.consensi": "Consensi *",
  "dottnet.wall.anagrafica": "Dati Personali",
  "dottnet.wall.accept": "Acconsento",
  "dottnet.wall.notaccept": "Non acconsento",
  "dottnet.wall.conditions": "Le nostre condizioni di utilizzo sono",
  "dottnet.wall.datainformative": "La nostra Informativa sull'utilizzo dei dati (compresa la sezione dedicata all'uso dei cookie) è",
  "dottnet.wall.here": "qui",
  "dottnet.wall.codicefiscale": "Codice fiscale",
  "dottnet.wall.codiceBelfiore": "Codice Belfiore",
  "dottnet.wall.dataNascita": "Data di nascita",
  "dottnet.wall.nome": "Nome",
  "dottnet.wall.cognome": "Cognome",
  "dottnet.wall.fotoUtente": "Foto utente",
  "dottnet.wall.iconaUtente": "Icona utente",
  "dottnet.wall.sesso": "Sesso",
  "dottnet.wall.provincia": "Provincia",
  "dottnet.wall.numeroIscrizioneAlbo": "Iscrizione all'albo",
  "dottnet.wall.cap": "CAP",
  "dottnet.wall.anc": "Anc",
  "dottnet.wall.completaProfilo": "Completa Profilo",
  "dottnet.wall.bodyConsent": "Gentile utente, abbiamo apportato delle modifiche alla nostra informativa privacy per garantirle una maggiore trasparenza e protezione dei suoi dati personali. La invitiamo pertanto a prendere visione della nostra nuova <a target='_blank' href='/privacy'>informativa</a> così da aggiornare i consensi.",
  "dottnet.wall.bodyGeneral": "Prima di proseguire, consideri la compilazione dei seguenti campi",
  "dottnet.wall.emailConfirm.title": "Aggiorna la tua email",
  "dottnet.wall.emailConfirm.body": "La tua email ({{email}}) potrebbe non essere più valida. Inserisci o riconferma il tuo indirizzo email per continuare a ricevere le nostre comunicazioni.",
  "dottnet.wall.emailConfirm.titleMissing": "Inserisci la tua email",
  "dottnet.wall.emailConfirm.bodyMissing": "Inserisci il tuo indirizzo email per continuare a ricevere le nostre comunicazioni.",
  "dottnet.specialty.selezionaspecialty": "Seleziona specializzazione",
  "dottnet.category.selezionacategory": "Seleziona categoria",
  "dottnet.province.selezionaprovince": "Seleziona provincia",
  "dottnet.pagina.piuletti": "Più letti",
  "dottnet.pagina.ultimivideo": "Ultimi video",
  "dottnet.article.related": "I Correlati",
  "dottnet.article.interested": "Ti potrebbero interessare",
  "dottnet.article.notmissed": "Da non perdere",
  "dottnet.article.latest": "Ultime News",
  "dottnet.permessi.login": "Gentile utente il contenuto è riservato, si prega di effettuare la login",
  "dottnet.permessi.unauthorizedTitle": "Non Autorizzato",
  "dottnet.permessi.unauthorized": "Gentile utente non è autorizzato a visualizzare il contenuto",
  "dottnet.permessi.notFoundTitle": "Contenuto non trovato",
  "dottnet.permessi.activateMail": "Attivazione Account",
  "dottnet.permessi.notFound": "Gentile utente il contenuto che sta cercando non esiste",
  "dottnet.permessi.sessionExpiredTitle": "Sessione Scaduta",
  "dottnet.permessi.sessionExpired": "Gentile utente, la sua sessione è scaduta. La preghiamo di effettuare nuovamente il login",
  "dottnet.permessi.genericPermission": "Gentile utente, per poter proseguire è necessario autenticarsi",
  "dottnet.permessi.commentPermission": "Gentile utente, per poter commentare è necessario autenticarsi",
  "dottnet.permessi.attenzione": "Attenzione",
  "dottnet.button.save": "Salva",
  "dottnet.button.delete": "Cancella",
  "dottnet.button.send": "Invia",
  "dottnet.button.changePassword": "Cambia password",
  "dottnet.button.changeEmail": "Cambia email",
  "dottnet.email.update.currentEmail": "Email attuale",
  "dottnet.email.update.newEmail": "Nuova email",
  "dottnet.email.update.success": "Email aggiornata. Ti abbiamo inviato un link di conferma.",
  "dottnet.button.consents.fine": "Ho capito",
  "dottnet.button.consents.confirm": "Conferma",
  "dottnet.button.unsubscribe": "Segui già",
  "dottnet.button.subscribe": "Segui",
  "dottnet.label.ecmInfos": "Dati Ecm",
  "dottnet.label.professionalInfos": "Dati Professionali",
  "dottnet.label.yes": "Sì",
  "dottnet.label.no": "No",
  "dottnet.label.sponsor": "Indicare società di riferimento",
  "dottnet.label.ecm": "Ecm. Clicchi la spunta se pensa di voler partecipare a qualche corso Ecm",
  "dottnet.label.name": "Nome",
  "dottnet.label.cellulare": "Cellulare",
  "dottnet.label.cap": "CAP",
  "dottnet.label.surname": "Cognome",
  "dottnet.label.email": "Email",
  "dottnet.label.password": "Password",
  "dottnet.label.codiceFiscale": "Codice fiscale",
  "dottnet.label.birthdate": "Data di nascita",
  "dottnet.label.bornAbroad": "Nato all'estero",
  "dottnet.label.birthplace": "Comune di nascita",
  "dottnet.label.professionplace": "Comune dove esercita",
  "dottnet.label.professionType": "Tipo di professione",
  "dottnet.label.agenasdisciplineType": "Disciplina",
  "dottnet.label.birthplace.question": "Nato all'estero?",
  "dottnet.label.gender": "Sesso",
  "dottnet.label.gender.M": "Uomo",
  "dottnet.label.gender.F": "Donna",
  "dottnet.label.category": "Categoria",
  "dottnet.label.specialty": "Specializzazione",
  "dottnet.label.registerNumber": "Numero di iscrizione all'albo",
  "dottnet.label.registerCity": "Provincia di iscrizione all'albo",
  "dottnet.label.consents.marketing": "Marketing",
  "dottnet.label.consents.marketingThirdParties": "Marketing Cessione Terzi",
  "dottnet.label.consents.profiling": "Profilazione",
  "dottnet.label.consents.profilingThirdParties": "Profilazione Cessione Terzi",
  "dottnet.label.consents.tracking": "Misurazione aperture newsletter",

  "dottnet.title.comments": "Commenti",
  "dottnet.field.label.comments": "Aggiungi un commento ",
  "dottnet.field.label.comments.replying": "In risposta a",
  "dottnet.field.label.comments.showMore": "{{ numCommenti }} Risposte",
  "dottnet.field.label.comments.reply": "Rispondi",
  "dottnet.field.label.comments.attachment": "Nessun file caricato",
  "dottnet.field.error.comments": "Scrivi prima qualcosa",

  "dottnet.home.medlex": "Medlex",
  "dottnet.home.bulletin": "Bollettino Ministeriale",
  "dottnet.home.aifa": "Aifa Comunica",
  "dottnet.home.institutions": "Istituzioni",
  "dottnet.home.insights": "Trova Qualcosa da Guardare",
  "dottnet.home.guideline": "Linee Guida",

  "dottnet.home.focusMedicina": "Focus in Medicina",
  "dottnet.home.focusVideo": "Video in Evidenza",
  "dottnet.home.obesity": "Obesità",
  "dottnet.home.generalMedicine": "Medicina Generale",
  "dottnet.home.topCategories": "Argomenti Più Cliccati",
  "dottnet.home.topSpecializations": "Specializzazioni Più Cliccate",
  "dottnet.home.latestNews": "Ultime Notizie",

  "dottnet.label.oldPassword": "Vecchia Password",
  "dottnet.label.newPassword": "Nuova Password",
  "dottnet.label.confirmNewPassword": "Conferma Password",

  "dottnet.consents.accept": "Acconsento",
  "dottnet.consents.reject": "Non acconsento",
  "dottnet.consents.error": "Selezionare almeno una scelta",

  "dottnet.hint.email": "Contattare il nostro servizio clienti per modificare l'email",
  "dottnet.hint.emailChecking": "Verifica in corso...",
  "dottnet.hint.password": "La password deve contenere almeno 8 caratteri tra cui una lettera minuscola, una maiuscola e un simbolo alfanumerico",
  "dottnet.field.error.cellulare": "Il valore immesso per il cellulare non è valido",
  "dottnet.field.error.numeric": "Il valore immesso non è numerico",
  "dottnet.field.error.required": "è un campo obbligatorio",
  "dottnet.field.error.email": "Digitare un'email valida. Esempio: prova@example.com",
  "dottnet.field.error.mailExistence": "La mail inserita è già presente nel nostro sistema. Hai dimenticato la password?",
  "dottnet.field.error.cfExistence": "Il codice fiscale inserito è già presente nel nostro sistema. Se credi sia un errore, contatta il nostro servizio clienti",
  "dottnet.field.error.cfLength": "Il codice fiscale deve essere lungo 16 caratteri",
  "dottnet.field.error.password": "Digitare una password valida. La password deve contenere almeno 8 caratteri tra cui una lettera minuscola, una maiuscola e un simbolo alfanumerico. Esempio: 9kY&epKG",
  "dottnet.field.error.invalidAge": "L'utente deve essere maggiorenne",
  "dottnet.field.error.registerForm": "Il modulo di iscrizione all'albo è obbligatorio",
  "dottnet.field.error.consentsForm": "Compilare il modulo consensi per intero",
  "dottnet.field.error.passwordMismatch": "Password e Conferma Password devono coincidere",
  "dottnet.field.error.emptyObject": "E' obbligatorio selezionare un valore. Iniziare a digitare.",

  "dottnet.dialog.consents.title": "Consensi",
  "dottnet.dialog.consents.marketing": "Solo previo Suo distinto ed esplicito consenso, al trattamento dei miei dati da parte del Titolare per le Finalità di Marketing di cui al punto 2.B) dell’Informativa (cioè per inviarmi comunicazioni e materiale pubblicitario o di vendita diretta di terzi soggetti, aventi contenuto commerciale, promozionale, pubblicitario e/o finalizzato all'informazione medico-scientifica; nonché per il compimento di ricerche di mercato, sondaggi d’opinione e analisi statistiche per finalità di marketing anche tramite raccolta del consenso per conto degli stessi. Il tutto può avvenire mediante l’uso di sistemi automatizzati di chiamata e/o email e/o fax e/o sms e/o mms e/o altri servizi di messaging e/o newsletter, e/o mediante modalità di marketing tradizionale come il telefono e/o posta cartacea)",
  "dottnet.dialog.consents.marketingThirdParties": "Solo previo Suo distinto ed esplicito consenso, alla comunicazione dei miei dati ai soggetti indicati all’art. 6 dell’Informativa, affinchè questi li trattino direttamente per le proprie Finalità di Marketing di cui al punto 2.D) dell’informativa  (ossia per inviarmi comunicazioni e materiale pubblicitario o di vendita diretta, aventi contenuto commerciale, promozionale, pubblicitario e/o finalizzato all'informazione medico-scientifica; nonché per il compimento di ricerche di mercato, sondaggi d’opinione e analisi statistiche per finalità di marketing. Il tutto mediante l’uso di sistemi automatizzati di chiamata e/o email e/o fax e/o sms e/o mms e/o altri servizi di messaging e/o newsletter, e/o mediante modalità di marketing tradizionale telefono e/o posta cartacea)",
  "dottnet.dialog.consents.profiling": "Solo previo Suo distinto ed esplicito consenso, al trattamento dei miei dati da parte del Titolare per le Finalità di Profilazione di cui al punto 2.C) dell’Informativa (cioè per analisi delle mie abitudini e scelte di consumo, di acquisto e professionali, svolte attraverso operazioni di segmentazione e tramite raccolta e analisi di sottogruppi di medici in base alle loro abitudini di navigazione, all’età ed alla specializzazione, volti unicamente ad orientare nel modo migliore la proposta di contenuti ed iniziative alle preferenze dell’utente, e ad evitare di proporgli argomenti non di suo interesse, ai fini dell’invio di comunicazioni e materiale pubblicitario o di vendita diretta su prodotti/servizi/iniziative e/o ricerche di mercato e/o sondaggi d’opinione e/o analisi statistiche di terzi soggetti, anche mediante l’uso di sistemi automatizzati di chiamata e/o email e/o fax e/o sms e/o mms e/o altri servizi di messaging e/o newsletter e/o telefono e/o posta cartacea)",
  "dottnet.dialog.consents.profilingThirdParties": "Solo previo Suo distinto ed esplicito consenso, alla comunicazione dei miei dati ai soggetti indicati all’art. 6 dell’Informativa, affinchè questi li trattino direttamente per le proprie Finalità di Profilazione di cui al punto 2.E) dell’informativa con annessa categoria e appartenenza ai“ gruppi” ai fini di svolgimento delle proprie attività di profilazione(finalizzate allo svolgimento da parte dei terzi di proprie analisi, invio di newsletter e sondaggi, comunicazioni di marketing diretto) anche mediante l’ uso di sistemi automatizzati di chiamata e / o email e / o fax e / o sms e / o mms e / o altri servizi di messaging e / o newsletter e / o telefono e / o posta cartacea)",
  "dottnet.dialog.consents.tracking": "Facoltativo. Acconsento a che Merqurio rilevi, tramite un pixel inserito nelle newsletter, se e quando apro le email ricevute, al fine di misurare l'efficacia delle comunicazioni. Il consenso può essere revocato in ogni momento dal profilo o dal link presente in ogni newsletter; in mancanza di consenso continuerò a ricevere le newsletter.",

  "dottnet.notification.info": "Operazione avvenuta",
  "dottnet.notification.success": "Operazione eseguita con successo!",
  "dottnet.notification.error": "Operazione fallita! Riprovare",
  "dottnet.notification.ok": "OK",

  "dottnet.lista.leggimi": "Leggimi",
  "dottnet.lista.guardami": "Guardami",
  "dottnet.lista.apri": "Apri",

  "dottnet.confirmMail.text": "La preghiamo di attivare il Suo account cliccando sull'apposito link inviato alla Sua casella di posta elettronica indicata in fase di registrazione.\n\nNel caso quest'ultima non Le risultasse recapitata,\nLa preghiamo di controllare nella posta indesiderata oppure richiedere un nuovo link d'attivazione tramite il tasto presente in questa pagina",
  "dottnet.confirmMail.text.expired": "Siamo spiacenti ma il link d'attivazione in Suo possesso è scaduto. Abbiamo provveduto all'invio di una nuova mail d'attivazione al suo indirizzo di posta elettronica. Può richiedere l'invio di una nuova mail cliccando sul bottone dedicato.",
  "dottnet.confirmMail.button": "Invia Mail",
  "dottnet.confirmMail.returnToDrClick": "Ritorna a DrClick",

  "dottnet.emailConfirm.title": "Conferma la tua email",
  "dottnet.emailConfirm.body.free": "Ricordati di confermare la tua email. Controlla la casella di {{email}}.",
  "dottnet.emailConfirm.body.locking": "Devi confermare la tua email per continuare ad utilizzare il portale. Controlla la casella di {{email}}.",
  "dottnet.emailConfirm.button.resend": "Rinvia link di conferma",
  "dottnet.emailConfirm.button.resendCooldown": "Rinvia link ({{seconds}}s)",
  "dottnet.emailConfirm.button.updateEmail": "Aggiorna mail",
  "dottnet.emailConfirm.button.notNow": "Non ora",
  "dottnet.emailConfirm.button.cancel": "Annulla",
  "dottnet.emailConfirm.message.confirmationResent": "Link di conferma rinviato con successo",

  "dottnet.text.welcome": "Benvenuto in DottNet!",
  "dottnet.text.sign": "Il Team DottNet",

  "dottnet.log.text": "Gentile Utente, questa pagina permette di ricevere assistenza dal nostro servizio clienti. Qualora ne avesse bisogno, può contattarci allo 800.014.863",
  "dottnet.log.empty": "Nessun log in memoria",
  "dottnet.log.records": "Sono presenti al momento ",
  "dottnet.log.delete": "Per cancellare tutti i log di Dottnet  ",
  "dottnet.log.send": "Per inviare i log di Dottnet all'assistenza ",
  "dottnet.log.reload": "Ricarica",

  "dottnet.message.changedpassword": "Password cambiata con successo!",
  "dottnet.message.retrievepassword": "Password reuperata con successo! Controlla la tua mail",
  "dottnet.message.activationMailSent": "Mail d'attivazione inviata con successo!",

  "dottnet.error.11": "Username o password errati",
  "dottnet.error.24": "Username o password vuoti",
  "dottnet.error.44": "Id Sito non trovato",
  "dottnet.error.45": "Gentile Utente, ci risulta che hai chiesto la cancellazione da Dottnet, e quindi abbiamo provveduto a disabilitare il tuo account. Per poter accedere contattaci al n. verde 800.014.863 oppure manda una mail a assistenzaextra@dottnet.it Cordiali saluti La redazione Dottnet",
  "dottnet.error.46": "Specializzazione non iscritta al sito convenzionato",
  "dottnet.error.47": "Categoria non iscritta al sito convenzionato",
  "dottnet.error.48": "Utente non iscritto al sito convenzionato",
  "dottnet.error.49": "Consenso Privacy non ancora espresso",
  "dottnet.error.50": "Consenso Marketing non ancora espresso",
  "dottnet.error.51": "Consenso Profilazione non ancora espresso",
  "dottnet.error.52": "Consenso Marketing Terzi non ancora espresso",
  "dottnet.error.53": "Consenso Profilazione Terzi non ancora espresso",
  "dottnet.error.100": "Gentile utente, poiché sta navigando in incognito, non potremo salvare le sue credenziali",

    "dottnet.search.title": "Risultati di ricerca per",
    "dottnet.search.containerinfo": "presente nel",
    "dottnet.search.toofewcharacters": "Inserire almeno tre caratteri",

  "dottnet.consent.header": "Teniamo alla vostra privacy",
  "dottnet.consent.body": "Noi e i nostri partner utilizziamo tecnologie come i cookie o il targeting ed elaboriamo dati personali come l'indirizzo IP o le informazioni sul browser per personalizzare gli annunci che visualizziamo. Queste tecnologie possono accedere al vostro dispositivo e aiutarci a mostrarvi annunci più pertinenti e a migliorare la vostra esperienza sul sito web. Utilizziamo queste tecnologie anche per misurare i risultati o per indirizzare meglio i contenuti del nostro sito web. Poiché teniamo alla vostra privacy, con la presente chiediamo il vostro consenso all'utilizzo delle seguenti tecnologie. È possibile modificare/revocare tale consenso in qualsiasi momento facendo clic sul pulsante Impostazioni nell'angolo in basso a sinistra della pagina..",
  "dottnet.consent.privacy_text": "Politica sulla privacy",
  "dottnet.consent.imprint_text": "Chi Siamo",
  "dottnet.consent.privacy_settings_text": "Gestisci preferenze",
  "dottnet.consent.decline_text": "RIFIUTA",
  "dottnet.consent.accept_text": "ACCETTA TUTTI",
  "dottnet.consent.save_text": "SALVA PREFERENZE",
  "dottnet.consent.back_text": "Indietro",
  "dottnet.consent.privacy_settings_title": "Impostazioni sulla privacy",
  "dottnet.consent.privacy_settings_title_text": "Questo menu vi aiuta a selezionare e disattivare i vari cookie, tracker e strumenti di analisi utilizzati su questo sito web.",
  "dottnet.consent.functional_title": "Funzionali",
  "dottnet.consent.functional_description": "Questi cookie ci consentono di analizzare l'utilizzo del sito web per poterne misurare e migliorare le prestazioni.",
  "dottnet.consent.marketing_title": "Marketing",
  "dottnet.consent.marketing_description": "I cookie di marketing sono solitamente utilizzati per mostrarvi pubblicità che rispondono ai vostri interessi. Quando visitate un altro sito web, il cookie del vostro browser viene riconosciuto e vi vengono mostrati annunci selezionati in base alle informazioni memorizzate in questo cookie (art. 6 par. 1 p. 1 a) GDPR).",
  "dottnet.consent.essential_title": "Essenziali",
  "dottnet.consent.essential_description": "Questi cookie sono necessari per le funzioni di base del sito web..",
  "dottnet.consent.cookie_name": "Nome",
  "dottnet.consent.cookie_description": "Descrizione",
  "dottnet.consent.cookie_duration": "Durata",
  "dottnet.consent.right_bottom": "È possibile modificare/revocare tale consenso in qualsiasi momento facendo clic sul pulsante Impostazioni nell'angolo in basso a destra della pagina.",
  "dottnet.consent.left_bottom": "È possibile modificare/revocare tale consenso in qualsiasi momento facendo clic sul pulsante Impostazioni nell'angolo in basso a sinistra della pagina.",
  "dottnet.consent.right_top": "È possibile modificare/revocare tale consenso in qualsiasi momento facendo clic sul pulsante Impostazioni nell'angolo in alto a destra della pagina.",
  "dottnet.consent.left_top": "È possibile modificare/revocare tale consenso in qualsiasi momento facendo clic sul pulsante Impostazioni nell'angolo in alto a sinistra della pagina.",

  "dottnet.consent.functionalCookies.name": "Google Analytics",
  "dottnet.consent.functionalCookies.description": "Google Analytics è un servizio di analisi web offerto da Google che tiene traccia e segnala il traffico del sito web.",
  "dottnet.consent.marketingCookiesGa.name": "Google Analytics",
  "dottnet.consent.marketingCookiesGa.description": "Google Analytics è un servizio di analisi web offerto da Google che tiene traccia e segnala il traffico del sito web.",
  "dottnet.consent.marketingCookiesGa.privacyPolicyUrl": "https://policies.google.com/privacy?hl=it",
  "dottnet.consent.marketingCookiesMeta.name": "Meta",
  "dottnet.consent.marketingCookiesMeta.description": "Meta è un'impresa statunitense che controlla i servizi di rete sociale Facebook e Instagram",
  "dottnet.consent.marketingCookiesMeta.privacyPolicyUrl": " https://www.facebook.com/privacy/policies/cookies/",
  "dottnet.consent.functionalCookies.privacyPolicyUrl": "https://policies.google.com/privacy",
  "dottnet.consent.functionalCookiesGA.description": "Questo cookie viene utilizzato per distinguere gli utenti.",
  "dottnet.consent.functionalCookiesGA.duration": "2 anni",
  "dottnet.consent.functionalCookiesGID.description": "Questo cookie viene utilizzato per distinguere gli utenti.",
  "dottnet.consent.functionalCookiesGID.duration": "24 ore",
  "dottnet.consent.functionalCookiesGAT.description": "Questo cookie viene utilizzato per limitare la frequenza delle richieste.",
  "dottnet.consent.functionalCookiesGAT.duration": "1 minuto",
  "dottnet.consent.functionalCookiesGTAG.description": "Questo cookie viene utilizzato per limitare la frequenza delle richieste.",
  "dottnet.consent.functionalCookiesGTAG.duration": "1 minuto",
  "dottnet.consent.functionalCookiesTOKEN.description": "Questo cookie viene utilizzato per limitare la frequenza delle richieste.",
  "dottnet.consent.functionalCookiesTOKEN.duration": "1 minuto",
  "dottnet.consent.marketingCookiesGaGA.description": "Questo cookie viene utilizzato per distinguere gli utenti.",
  "dottnet.consent.marketingCookiesGaGA.duration": "2 anni",
  "dottnet.consent.essentialCookies.description": "Questo cookie è utilizzato per garantire il corretto funzionamento di dottnet.it",
  "dottnet.consent.essentialCookies.privacyPolicyUrl": "https://www.dottnet.it/privacy",
  "dottnet.consent.thirdpartyconsent.accepted": "Abbiamo registrato il consenso da lei dato all'azienda: ",
  "dottnet.consent.thirdpartyconsent.failed": "Errore durante la registrazione del consenso. Riprovare",
  "dottnet.disiscrizione.single": "Stai disattivando la ricezione della newsletter",
  "dottnet.disiscrizione.allTitle": "Disiscrizione Newsletter",
  "dottnet.disiscrizione.all": "Confermi di voler disiscriverti da tutte le newsletter",
  "dottnet.disiscrizione.dottnet": "Confermi di volerti cancellare da DottNet",
  "dottnet.disiscrizione.dottnetTitle": "Disiscrizione da DottNet",
  "dottnet.disiscrizione.conferma": "Conferma",
  "dottnet.disiscrizione.annulla": "Annulla",
  "dottnet.disiscrizione.allIntention": "Per cancellarti da tutte le Newsletter clicca qui",
  "dottnet.disiscrizione.dottnetIntention": "Per cancellarti da DottNet clicca qui",
  "dottnet.disiscrizione.unknowUser": "Utente sconosciuto",
  "dottnet.disiscrizione.unknowUserDescription": "Per poterti disiscrivere, abbiamo bisogno di sapere chi sei.",
  "dottnet.disiscrizione.login": "Per loggarti, clicca qui.",
  "dottnet.tracciamento.title": "Misurazione delle aperture delle newsletter",
  "dottnet.tracciamento.info": "Le newsletter di DottNet possono contenere un pixel che ci permette di sapere se e quando apri le email, per misurare l'efficacia delle comunicazioni. Puoi cambiare la tua scelta in qualsiasi momento, qui o dal tuo profilo: in ogni caso continuerai a ricevere le newsletter.",
  "dottnet.tracciamento.lastChoice": "Ultima scelta registrata il",
  "dottnet.tracciamento.notExpressed": "Non hai ancora espresso una scelta: per ora l'apertura delle newsletter viene misurata.",
  "dottnet.tracciamento.save": "Salva la scelta",
  "dottnet.tracciamento.doneConsent": "La tua scelta è stata registrata: misureremo l'apertura delle newsletter che ricevi.",
  "dottnet.tracciamento.doneRevoke": "La tua scelta è stata registrata: da ora non misureremo più l'apertura delle newsletter che ricevi.",
  "dottnet.tracciamento.loading": "Caricamento in corso...",
  "dottnet.tracciamento.invalid": "Il link non è valido o è scaduto. Puoi gestire il consenso dal tuo profilo.",
  "dottnet.tracciamento.profile": "Vai al profilo",
  "dottnet.tracciamento.error": "Si è verificato un errore.",
  "dottnet.tracciamento.retry": "Riprova",
  "dottnet.iscrizione.title": "Complimenti, l'iscrizione alla newsletter è avvenuta con successo!",
  "dottnet.iscrizione.unknowUserDescription": "Per poterti iscrivere, abbiamo bisogno di sapere chi sei.",
  "dottnet.iscrizione.remove": "Clicca qui per annullare l'iscrizione.",
  "dottnet.footer.chiSiamo": "Chi siamo",
  "dottnet.footer.redazione": "Redazione",
  "dottnet.footer.contatti": "Contatti",
  "dottnet.footer.seguici": "seguici su",
  "dottnet.footer.numeroVerde": "Numero Verde 800 014 863",
  "dottnet.footer.honCode": "Aderiamo allo ",
  "dottnet.footer.honCode2": "standard HONcode per l'affidabilità dell'informazione medica",
  "dottnet.footer.check": "Verifica qui.",
  "dottnet.footer.condizioni": "Condizioni di utilizzo",
  "dottnet.footer.cookies": "Cookie",
  "dottnet.footer.privacy": "Privacy",
  "dottnet.footer.cancellazione": "Cancellazione",
  "dottnet.footer.company": "Merqurio Editore s.r.l. - Partita IVA: 05877761212 ",
  "dottnet.footer.newsletter.title": "Iscriviti alla Newsletter",
  "dottnet.footer.newsletter.emailPlaceholder": "Inserisci qui la tua email",
  "dottnet.footer.newsletter.privacyNotice": "Ho preso visione dell'informativa.",
  "dottnet.footer.newsletter.subscribe": "Iscriviti",
  "dottnet.footer.followus": "Seguici sui Social",
  "dottnet.footer.inform": "Informati",
  "dottnet.footer.companySection.title": "Chi Siamo",
  "dottnet.footer.companySection.description": "<strong>DottNet</strong> è il social network di <strong>Merqurio Editore srl</strong> dedicato ai professionisti della sanità italiana. Fin dal suo esordio, nell'anno 2008, ha avuto l'obiettivo di contribuire qualitativamente allo sviluppo professionale degli operatori sanitari offrendo un'ampia gamma di contenuti scientifici quali articoli, casi clinici scritti da e per i medici, report dei congressi, consigli dei servizi utili allo svolgimento della pratica clinica e all'aggiornamento professionale.",
  "dottnet.footer.readMore": "Leggi tutto",
  "dottnet.footer.contacts.companyName": "Merqurio Editore srl",
  "dottnet.footer.contacts.address": "Via Santa Brigida, 68 – 80132 NA",
  "dottnet.footer.contacts.vatLabel": "Partita IVA",
  "dottnet.footer.contacts.phone": "800 014 863",

  "dottnet.headerBanner.lastUpdate": "Ultimo contenuto aggiunto:",

  "dottnet.extra.duration_3": "/ 3 mesi",
  "dottnet.extra.duration_6": "/ 6 mesi",
  "dottnet.extra.duration_9": "/ 9 mesi",
  "dottnet.extra.duration_12": "/ 1 anno",
  "dottnet.extra.duration_24": "/ 2 anni",
  "dottnet.extra.duration_default": " mesi",
  "dottnet.extra.invoice": "Desideri la fattura?",
  "dottnet.extra.invoiceDetail": "Inserire numero di partita IVA e PEC oppure SD.",
  "dottnet.extra.invoiceVat": "Inserisci partita Iva",
  "dottnet.extra.invoicePec": "Inserisci Pec.",
  "dottnet.extra.invoiceSd": "Inserisci SD",
  "dottnet.extra.Vat": "Partita Iva",
  "dottnet.extra.Pec": "Pec",
  "dottnet.extra.Sd": "SD",
  "dottnet.extra.total": "TOTALE:",
  "dottnet.extra.finalTotal": "(TOTALE effettivo):",
  "dottnet.extra.finalTotalCondition": "Il tuo abbonamento scade il ",
  "dottnet.extra.finalTotalCondition2": ". Anzichè ",
  "dottnet.extra.finalTotalCondition3": "€ ti addebiteremo ",
  "dottnet.extra.finalTotalCondition4": "€ per integrare l'abbonamento esistente.",
  "dottnet.extra.terms": "Termini e condizioni",
  "dottnet.extra.condition": "Leggi e approva le Condizioni del servizio. Cliccando su Prosegui dichiari di aver letto e approvato specificamente gli articoli da 1 a 16 delle Condizioni particolari del ",
  "dottnet.extra.condition2": "Servizio",
  "dottnet.extra.prosegui": "Prosegui",
  "dottnet.extra.paga": "Paga",
  "dottnet.extra.coming": "Cooming soon",
  "dottnet.extra.valuta": "€",
  "dottnet.extra.codiceSconto": "Codice Sconto",
  "dottnet.extra.applicaSconto": "Applica",
  "dottnet.extra.personalization": "Attiva subito il tuo abbonamento Base",
  "dottnet.extra.login": "Loggati per scoprire il mondo Dottnet eXtra",
  "dottnet.extra.payment.email": "Email",
  "dottnet.extra.payment.name": "Nome",
  "dottnet.extra.payment.processing": "Elaborazione in corso",
  "dottnet.extra.payment.pay": "Paga",
  "dottnet.extra.sellerFormAnagrafica": "Inserisci Anagrafica",
  "dottnet.extra.sellerFormNome": "Nome Anagrafica",
  "dottnet.extra.sellerFormCognome": "Cognome Anagrafica",
  "dottnet.extra.sellerFormMail": "Mail Anagrafica",
  "dottnet.extra.sellerFormPremium": "Premium Anagrafica",
  "dottnet.extra.sellerFormDataInizio": "Data Inizio Abbonamento",
  "dottnet.extra.sellerFormDataFine": "Data Fine Abbonamento",
  "dottnet.extra.sellerFormCarica": "Carica Anagrafica",
  "dottnet.extra.sellerAbbonato": "Abbonato Premium",
  "dottnet.extra.sellerNonAbbonato": "NON Abbonato Premium",
  "dottnet.extra.selectCoupon": "Seleziona Coupon",
  "dottnet.extra.createCoupon": "GENERA COUPON SCONTO",
  "dottnet.extra.deleteSubscriptionAll": "Disdici tutto l'abbonamento alla scadenza",
  "dottnet.extra.deleteSubscription": "Disdici il pacchetto alla scadenza",
  "dottnet.extra.activateSubscription": "Riattiva l'abbonamento alla scadenza",
  "dottnet.extra.reserved": "Articolo riservato agli abbonati di Dottnet eXtra",
  "dottnet.extra.base": "<h1> DottNet eXtra</h1> <p>Il tuo accesso esclusivo a contenuti scientifici di alto livello e consulenza previdenziale online per medici.</p><p>Aggiornarti in modo efficace e prendere decisioni previdenziali consapevoli non è mai stato così semplice.</p><p><strong>Con DottNet eXtra Base hai a disposizione uno spazio riservato, pensato per supportare concretamente la tua professione, ogni giorno. </strong>Abbiamo creato questo servizio ascoltando le esigenze reali di migliaia di colleghi medici in tutta Italia: meno tempo perso, più valore, più supporto qualificato.</p><p>Perché scegliere DottNet eXtra Base</p><p>Con un unico abbonamento ottieni strumenti ad alto impatto professionale:</p><ul><li><strong>Articoli scientifici completi</strong> ad altissimo valore aggiunto. Contenuti approfonditi, autorevoli e subito utili per rimanere aggiornato in modo serio e affidabile.</li><li><strong>Consulenza previdenziale specializzata online.</strong> Supporto professionale per orientarti nelle scelte previdenziali, con risposte chiare e personalizzate, comodamente da remoto. </li></ul><p>I vantaggi per te</p><ul><li>Risparmi tempo: trovi solo contenuti selezionati e di qualità</li><li>Prendi decisioni più consapevoli per il tuo futuro previdenziale</li><li>Accedi quando vuoi, da qualsiasi dispositivo</li><li>Nessun vincolo su prodotti o servizi: solo informazione e consulenza di valore</li></ul><p>Inizia ora</br>Entra oggi in DottNet eXtra Base e trasforma il tuo aggiornamento professionale in un vero vantaggio competitivo.</p>",
  "dottnet.extra.entra": "Entra nel mondo",
  "dottnet.extra.dtnExtra": "DottNet eXtra",
  "dottnet.extra.support": "Hai bisogno di supporto?",
  "dottnet.extra.call": "Chiama un nostro operatore al numero:",
  "dottnet.extra.freenumber": "800.072.636",
  "dottnet.extra.codutente": "Cod.utente",
  "dottnet.extra.totalEcm": "Punti ECM totali:",
  "dottnet.extra.availabelEcm": "Punti ECM disponibili:",
  "dottnet.extra.subscriptionFrom": "Abbonamento attivo dal",
  "dottnet.extra.subscriptionTo": "Scadenza abbonamento",
  "dottnet.extra.mycourses": "I miei corsi",
  "dottnet.extra.extraArticle": "Articoli Extra",
  "dottnet.extra.subscriptionOk": "Abbonamento attivato con successo",
  "dottnet.extra.subscriptionKo": "Qualcosa è andato storto durante il processo.</br> Contattare l'assistenza. Nulla è stato addebitato",
  "dottnet.extra.error": "Qualcosa è andato storto.</br> Contattare l'assistenza.",
  "dottnet.extra.invalidStatus": "Qualcosa è andato storto.Stato di conferma invalido.</br> Contattare l'assistenza. Payment Status: ",
  "dottnet.extra.disdetta": "<h1> DottNet eXtra</h1> <p>Disdetta avvenuta con successo!</p>",
  "dottnet.extra.welcome": "<h1> DottNet eXtra</h1> <p>Abbonamento attivato correttamente.</p><p>Benvenuto in <strong> eXtra.</strong></p>",
  "dottnet.extra.deactivated": "Pacchetto disattivato alla scadenza",
  "dottnet.extra.subscriptionExists": "Attenzione. Risulti già sottoscritto ai piani scelti.",
  "dottnet.shared.error": "Qualcosa è andato storto",
  "dottnet.userform.intro": "Registrandoti a Dottnet accetti le nostre",
  "dottnet.userform.condition": "Condizioni",
  "dottnet.userform.intro2": "Inoltre confermi di aver letto la nostra",
  "dottnet.userform.privacy": "Informativa",
  "dottnet.userform.intro3": "sull'utilizzo dei dati, compresa la sezione dedicata all'uso dei cookie.",
  "dottnet.notfound.h2": "Oops! Qualcosa è andato storto ",
  "dottnet.notfound.p": "La pagina che stai cercando potrebbe essere stata rimossa o non essere al momento disponibile.",
  "dottnet.notfound.a": "Ritorna alla Home",
  "dottnet.label.read": "Leggi",
  "dottnet.label.watch": "Guarda",
  "dottnet.profile.reserved": "Gentile utente, l'area profilo è riservata. Effettuare l'accesso",
  "dottnet.pdf.alertDownload": "Gentile utente il file non è scaricabile. L'uso è per sola lettura.",
  "dottnet.pdf.alertPrint": "Gentile utente il file non è stampabile. L'uso è per sola lettura.",
  "dottnet.errorcode.78": "Pagamento rifiutato. Fondi insufficienti sulla carta.",
  "dottnet.errorcode.79": "Pagamento rifiutato. La carta risulta smarrita.",
  "dottnet.errorcode.80": "Pagamento rifiutato. La carta risulta rubata.",
  "dottnet.errorcode.81": "Pagamento rifiutato. Carta scaduta.",
  "dottnet.errorcode.82": "Pagamento rifiutato. Codice CVC non corretto.",
  "dottnet.errorcode.83": "Pagamento rifiutato. Numero carta non corretto.",

  "dottnet.errorcode.85": "Errore durante l'iscrizione al corso. Fallito salvataggio iscrizione. Contattare l'assistenza.",
  "dottnet.errorcode.86": "Errore durante l'iscrizione al corso. Fallito salvataggio consensi. Contattare l'assistenza.",
  "dottnet.errorcode.87": "Errore durante l'iscrizione al corso. Fallito salvataggio dati ecm. Contattare l'assistenza.",

  "dottnet.shared.affermativo": "Sì",
  "dottnet.shared.negativo": "No",
  "dottnet.enrollement.ecm": "Rilascio crediti",
  "dottnet.enrollement.ecmWarning": "Hai indicato di non voler ricevere crediti ECM. Se sei sicuro della tua scelta, i crediti non saranno comunicati ad AGENAS e non verranno attribuiti",
  "dottnet.enrollement.enroll": "Reclutato*",
  "dottnet.enrollement.registration": "Iscriviti",
  "dottnet.enrollement.enrollLable": "*Si considera reclutato il professionista sanitario che, per la partecipazione ad eventi formativi, beneficia di vantaggi economici e non economici, diretti ed indiretti, da parte di imprese commerciali operanti in ambito sanitario",
  "dottnet.enrollement.registrationLable": "Iscrizione al corso",
  "dottnet.enrollement.enrollSuccess": "Iscrizione al corso avvenuta con successo.</br>Controlli la mail per i dettagli.",
  "dottnet.enrollement.enrolled": "Gentile utente, risulti già iscritto a questo corso.</br> Controlla la tua casella e-mail per la conferma di iscrizione.</br> Puoi richiedere l'invio di una nuova mail cliccando sul bottone dedicato.",
  "dottnet.poll.votes": "voti",
  "dottnet.poll.expiry": "giorni rimanenti",
  "dottnet.poll.undo": "Annulla",
  "dottnet.poll.closed": "Sondaggio chiuso",
  "dottnet.repblog.noinfo": "Siamo spiacenti, non ci risultano informatori assegnati alla tua area.",
  "dottnet.repblog.welcome1": "Benvenuto nell'area dedicata alla videocall,",
  "dottnet.repblog.welcome2": "per entrare in relazione diretta con un Informatore",
  "dottnet.repblog.info1": "Per maggiori informazioni,",
  "dottnet.repblog.info2": "può rivolgersi al numero verde:",
  "dottnet.repblog.info3": "800 014 863",
  "dottnet.meta.website.description": "DottNet è un portale medico con news, studi e approfondimenti per professionisti della salute.",
  "dottnet.meta.organization.description": "DottNet è un portale medico con news, studi, webinar e approfondimenti per medici, farmacisti e professionisti sanitari.",
  "dottnet.meta.organization.legalName": "Merqurio Editore s.r.l.",
  "dottnet.meta.organization.streetAddress": "Corso Umberto I, 23",
  "dottnet.meta.organization.addressLocality": "Napoli",
  "dottnet.meta.organization.postalCode": "80138",
  "dottnet.meta.organization.addressCountry": "IT",
  "dottnet.meta.contacts.telephone": "800.014.863",
  "dottnet.meta.contacts.email": "redazione@merqurio.it",
  "dottnet.meta.organization.department.name": "Redazione",
  "dottnet.minisiti.latestMinisiti": "Ultimi contenuti nei Minisiti",
  "dottnet.minisiti.latestCanali": "Ultimi contenuti nei Canali",
  "dottnet.label.evidenza": "In Evidenza",
  "dottnet.minisiti.titoloMinisiti": "Sfoglia nei Minisiti",
  "dottnet.minisiti.titoloCanali": "Sfoglia nei Canali",
  "dottnet.minisiti.specialita": "La tua specializzazione",
  "dottnet.minisiti.altro": "Dalla tua area",
  "dottnet.minisiti.generale": "Altro da Dottnet",
  "dottnet.minisiti.altroInteressanti": "Altro che potrebbe interessarti",
  "dottnet.label.novita": "Novità",
  "dottnet.label.account.signign": "Non hai un account?",
  "dottnet.placeholder.date": "DD/MM/AAAA",
  "dottnet.countdown.days": "Giorni",
  "dottnet.countdown.hours": "Ore",
  "dottnet.countdown.minutes": "Minuti",
  "dottnet.countdown.seconds": "Secondi",
  "dottnet.dropdownMidgetMenu.defaultTitle": "Menu",
  "dottnet.pec.title": "PEC DottNet",
  "dottnet.pec.label": "Gentile utente la sua pec non è configurata",
  "dottnet.label.leggimi": "Leggimi",
  "dottnet.label.guardami": "Guardami",
  "dottnet.label.leggiTutto": "Leggi Tutto",
  "dottnet.label.approfondimento": "Approfondimento",
  "dottnet.label.hotTopics": "I Più Letti",

  "dottnet.carousel.indietro": "Indietro",
  "dottnet.carousel.avanti": "Avanti",
  "dottnet.periodici.n": "N.",
  "dottnet.periodici.numero": "Numero",
  "dottnet.periodici.ultimoNumero": "Ultimo numero",
  "dottnet.periodici.leggiIlNumero": "Leggi il numero",
  "dottnet.periodici.tuttiINumeri": "Tutti i numeri",
  "dottnet.periodici.caricaAltriNumeri": "Carica altri numeri",
  "dottnet.periodici.numeriPubblicati": "numeri pubblicati",
  "dottnet.periodici.altriNumeri": "Altri numeri del periodico",
  "dottnet.periodici.stessoNumero": "Articoli dello stesso numero",
  "dottnet.sidenav.medici": "Medici",
  "dottnet.sidenav.istituzioni": "Istituzioni",
  "dottnet.sidenav.pazienti": "Pazienti",
  "dottnet.sidenav.argomenti": "Argomenti",
  "dottnet.sidenav.specializzazioni": "Specializzazioni",
  "dottnet.sidenav.quaderniDiMedicina": "Quaderni di Medicina",
  "dottnet.sidenav.eccellenzeInSanita": "Eccellenze in Sanità",
  "dottnet.sidenav.dossierDiDottnet": "Dossier di Dottnet",
  "dottnet.sidenav.minisiti": "Minisiti",
  "dottnet.sidenav.canali": "Canali",
  "dottnet.sidenav.conversazioni": "Conversazioni",
  "dottnet.sidenav.categorie": "Categorie",
  "dottnet.sidenav.extra": "eXtra",
  "dottnet.sidenav.news_approfondimenti": "News e Approfondimenti",
  "dottnet.sidenav.formazione": "Corsi ECM",
  "dottnet.sidenav.risorse_studi": "Risorse e Studi",

  "dottnet.sidenav.subjects.title": "Scegli un Argomento",
  "dottnet.sidenav.subjects.description": "Scegli uno degli Argomenti da approfondire tra quelli più cliccati.",
  "dottnet.sidenav.subjects.hint1": "Non hai trovato nulla di tuo interesse? Cerca con la",
  "dottnet.sidenav.subjects.searchBar": "Search Bar",
  "dottnet.sidenav.subjects.hint2": "qui sotto o consulta la pagina con tutti gli Argomenti facendo click su",
  "dottnet.sidenav.subjects.showAll": "Mostra Tutti",
  "dottnet.sidenav.subjects.searchPlaceholder": "Cerca un Argomento",
  "dottnet.sidenav.subjects.searchAriaLabel": "Cerca un argomento",
  "dottnet.sidenav.subjects.searchButtonAriaLabel": "Invia ricerca argomento",
  "dottnet.sidenav.subjects.showAllButton": "Mostra Tutti",
  "dottnet.sidenav.subjects.showLessButton": "Mostra Meno",
  "dottnet.sidenav.subjects.noResults": "Nessun argomento trovato",

  "dottnet.sidenav.specializations.title": "Scegli una Specializzazione",
  "dottnet.sidenav.specializations.description": "Clicca su una delle Specializzazioni per accedere a contenuti riguardanti esclusivamente la Specializzazione selezionata.",
  "dottnet.sidenav.specializations.hint1": "Non hai trovato la tua Specializzazione? Cercala con la",
  "dottnet.sidenav.specializations.searchBar": "Search Bar",
  "dottnet.sidenav.specializations.hint2": "qui sotto o consulta la pagina con tutte le Specializzazioni facendo click su",
  "dottnet.sidenav.specializations.showAll": "Mostra Tutte",
  "dottnet.sidenav.specializations.searchPlaceholder": "Cerca una Specializzazione",
  "dottnet.sidenav.specializations.searchAriaLabel": "Cerca una specializzazione",
  "dottnet.sidenav.specializations.searchButtonAriaLabel": "Invia ricerca specializzazione",
  "dottnet.sidenav.specializations.showAllButton": "Mostra Tutte",
  "dottnet.sidenav.specializations.showLessButton": "Mostra Meno",
  "dottnet.sidenav.specializations.noResults": "Nessuna specializzazione trovata",

  "dottnet.sidenav.notizie": "Notizie",
  "dottnet.sidenav.dossier": "Dossier",
  "dottnet.sidenav.interviste": "Interviste",
  "dottnet.sidenav.video": "Video",
  "dottnet.sidenav.corsi": "Corsi",
  "dottnet.sidenav.webinar": "Webinar",
  "dottnet.sidenav.podcast": "Podcast",
  "dottnet.sidenav.documenti": "Documenti",
  "dottnet.sidenav.studi": "Studi",

  "dottnet.usermenu.profile": "Profilo",
  "dottnet.usermenu.login": "Accedi",
  "dottnet.usermenu.extra": "eXtra",
  "dottnet.usermenu.discoverextra": "Scopri eXtra",
  "dottnet.usermenu.myextra": "Il mio eXtra",
  "dottnet.usermenu.mycourses": "I miei corsi",
  "dottnet.usermenu.managelog": "Gestisci Log",
  "dottnet.usermenu.logout": "Logout",

  "dottnet.search.placeholder": "Cerca qualcosa...",
  "dottnet.search.close": "Chiudi",
  "dottnet.search.mostSearched": "Molto cercati",
  "dottnet.search.noHistory": "Nessuna ricerca recente",
  "dottnet.search.noMostSearched": "Nessuna ricerca popolare disponibile",
  "dottnet.claim.title.prefix": "Su ",
  "dottnet.claim.title.highlight": "DottNet",
  "dottnet.claim.title.suffix": " trovi la miglior formazione ECM.",
  "dottnet.claim.subtitle": "Progetti formativi scientifici accreditati ECM, accessibili online e sviluppati con il supporto di specialisti del settore.",
  "dottnet.claim.button": "Scopri i nostri Corsi ECM.",
  "dottnet.claim.item1.title": "Fruizione digitale semplice",
  "dottnet.claim.item1.text": "Accedi ai corsi quando e dove vuoi, da qualsiasi dispositivo",
  "dottnet.claim.item2.title": "Contenuti aggiornati",
  "dottnet.claim.item2.text": "Formazione sempre aggiornata sulle novità cliniche e terapeutiche",
  "dottnet.claim.item3.title": "Qualità certificata",
  "dottnet.claim.item3.text": "Provider ECM n°7375, garanzia di qualità e affidabilità",

  "dottnet.extraCarousel.title": "EXTRA",

  "dottnet.claimreview.subtitle": "Scusaci l'interruzione.",
  "dottnet.claimreview.title": "Ti sta piacendo la nuova versione di DottNet?",
  "dottnet.claimreview.ratinggroup": "Valutazione",
  "dottnet.claimreview.minlabel": "Per nulla",
  "dottnet.claimreview.maxlabel": "Moltissimo",
  "dottnet.claimreview.commentlabel": "Commento",
  "dottnet.claimreview.placeholder": "Se vuoi, aggiungi anche un commento, una critica, un'idea in forma totalmente anonima. Raccontaci cosa ti piace e cosa invece no...",
  "dottnet.claimreview.submit": "Invia",

  "dottnet.topic-list.show-all": "Mostra Tutti",
  "dottnet.topic-list.show-less": "Mostra Meno"
}
